'use client'

export default function CustomCss(props) {

  if (!props.css) return <></>
  return <style jsx>{ `${props.css}` }</style>

}